import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Company Info */}
          <div>
            <h3 className="footer-brand">RapidNova</h3>
            <p className="footer-description">
              Creating innovative mobile applications that solve real-world problems 
              for everyday users through thoughtful design and cutting-edge technology.
            </p>
            <p className="footer-copyright">
              © 2025 RapidNova. All rights reserved.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li>
                <a href="#home">Home</a>
              </li>
              <li>
                <a href="#about">About</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </div>

          {/* Our Apps - Privacy & Terms */}
          <div className="footer-section">
            <h4>App Policies</h4>
            <ul className="footer-links">
              <li><Link to="/apps/ocracle/privacy-policy">OCRacle Privacy</Link></li>
              <li><Link to="/apps/cleanmind/privacy-policy">CleanMind Privacy</Link></li>
              <li><Link to="/apps/artrix/privacy-policy">Artrix Privacy</Link></li>
              <li><Link to="/apps/artrix/terms-of-service">Artrix Terms</Link></li>
              <li><Link to="/apps/aidg/privacy-policy">AiDG Privacy</Link></li>
              <li><Link to="/apps/aidg/terms-of-service">AiDG Terms</Link></li>
              <li><Link to="/apps/bank-statement-converter/privacy-policy">Bank Statement Converter Privacy</Link></li>
              <li><Link to="/apps/cpg/privacy-policy">CPG Privacy</Link></li>
              <li><Link to="/apps/onetap/privacy-policy">OneTap Privacy</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>Creating apps that make everyday life better.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 